<template>
  <div class="map-container" ref="mapContainer"
    :style="mapContainerStyle">
    <div class="map-wrapper" 
      :style="mapWrapperStyle"
      :class="mapClass"
    >
      <div class="cx-media__action m-media__action--sticky" v-show="isMapHide">
        <a class="cx-btn"
          @click.prevent="$store.dispatch('ui/DISMISS_MAP_ON_MOBILE')">
          <span>{{$t('action.close')}}</span>
        </a>
      </div>
      <div class="m-legend--abs" v-show="showSetting">
        <div class="cx-row--line">
          <div class="cx-t01">
            <sight-map-map-container-range :value="range" @changed="setPoisRange" />
            <div class="cx-list--sm">
              <div class="cx-list__item">
                <a role="button"  class="m-legend__link"
                  :class="poisToShow.sightseeing ? 'theme-color-sightseeing' : 'm-inactive'"
                  @click.prevent="setPoisToShow('sightseeing', !poisToShow.sightseeing)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-camera"></i> 
                  </span>
                  <span>{{ specialTranslation('sightseeing') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button"  class="m-legend__link"
                  :class="poisToShow['shows-and-entertainment'] ? 'theme-color-shows-and-entertainment' : 'm-inactive'"
                  @click.prevent="setPoisToShow('shows-and-entertainment', !poisToShow['shows-and-entertainment'])"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-theater-masks"></i> 
                  </span>
                  <span>{{ specialTranslation('shows-and-entertainment') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button"  class="m-legend__link"
                  :class="poisToShow.shopping ? 'theme-color-shopping' : 'm-inactive'"
                  @click.prevent="setPoisToShow('shopping', !poisToShow.shopping)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-shopping-bag"></i> 
                  </span>
                  <span>{{ specialTranslation('shopping') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.fnb ? 'theme-color-fnb' : 'm-inactive'"
                  @click.prevent="setPoisToShow('fnb', !poisToShow.fnb)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-utensils"></i> 
                  </span>
                  <span>{{ $t('common.fnb') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.restaurant ? 'theme-color-restaurant' : 'm-inactive'"
                  @click.prevent="setPoisToShow('restaurant', !poisToShow.restaurant)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-utensils"></i> 
                  </span>
                  <!-- <span>{{$t('common.restaurant')}}</span> -->
                  <span>{{$t('common.qtsasRestaurant')}}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button"  class="m-legend__link"
                  :class="poisToShow.whatson ? 'theme-color-whatson' : 'm-inactive'"
                  @click.prevent="setPoisToShow('whatson', !poisToShow.whatson)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-calendar-star"></i> 
                  </span>
                  <span>{{ $t('enf.searchHeader') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.hotel ? 'theme-color-hotel' : 'm-inactive'"
                  @click.prevent="setPoisToShow('hotel', !poisToShow.hotel)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-heading"></i>
                  </span>
                  <span>{{$t('common.hotel')}}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.lrt ? 'theme-color-lrt' : 'm-inactive'"
                  @click.prevent="setPoisToShow('lrt', !poisToShow.lrt)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-train-subway"></i>
                  </span>
                  <span>{{ $t('common.lrt') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button"  class="m-legend__link"
                  :class="poisToShow.freewifi ? 'theme-color-freewifi' : 'm-inactive'"
                  @click.prevent="setPoisToShow('freewifi', !poisToShow.freewifi)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-wifi"></i>
                  </span>
                  <span>{{ $t('common.wifi') || 'Wi-Fi' }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.touristinfo ? 'theme-color-touristinfo' : 'm-inactive'"
                  @click.prevent="setPoisToShow('touristinfo', !poisToShow.touristinfo)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-fw fa-info-circle"></i> 
                  </span>
                  <span>{{$t('common.touristInfomation')}}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.drink ? 'theme-color-drink' : 'm-inactive'"
                  @click.prevent="setPoisToShow('drink', !poisToShow.drink)"
                >
                  <span class="cx-link__icon">
                    <i class="fa-solid fa-droplet"></i>
                  </span>
                  <span>{{ $t('common.drink') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.nursingroom ? 'theme-color-nursingroom' : 'm-inactive'"
                  @click.prevent="setPoisToShow('nursingroom', !poisToShow.nursingroom)"
                >
                  <span class="cx-link__icon">
                    <i class="fa-solid fa-person-breastfeeding"></i>
                  </span>
                  <span>{{ $t('common.nursingroom') }}</span>
                </a>
              </div>
              <div class="cx-list__item">
                <a role="button" class="m-legend__link"
                  :class="poisToShow.publictoilet ? 'theme-color-publictoilet' : 'm-inactive'"
                  @click.prevent="setPoisToShow('publictoilet', !poisToShow.publictoilet)"
                >
                  <span class="cx-link__icon">
                    <!-- <i class="fas fa-fw fa-hand-holding-water"></i> -->
                    <i class="fa-solid fa-restroom-simple"></i>
                  </span>
                  <span>{{$t('common.publicToilet')}}</span>
                </a>
              </div>
              <!-- <div class="cx-list__item">
                <a class="cx-link"
                  :class="poisToShow.busstop ? 'theme-color-busstop' : 'm-inactive'"
                  @click.prevent="setPoisToShow('busstop', !poisToShow.busstop)"
                >
                  <span class="cx-link__icon">
                    <i class="fas fa-bus"></i>
                  </span>
                  <span>{{$t('common.busStop')}}</span>
                </a>
              </div> -->
            </div>
          </div>
          <span class="m-legend--close" @click="showSetting=false">
            <i class="fas fa-times"></i> 
          </span>
        </div>
      </div>
      <div
        v-if="disableMapbox"
        class="map-static-placeholder"
        aria-hidden="true"
      >
        <cx-img
          tag="i"
          class="m-graphic--ngi"
          imgSrc="/static/graphic/mgto_graphic_location.png"
        ></cx-img>
      </div>
      <div v-else id="map" ref="map"></div>
      <transition name="event-map-loading" :css="!!mapPageType">
        <div class="cx-modal map-loading" :class="{ 'event-map-loading': mapPageType }" v-if="loading">
          <div class="cx-modal__body">
            <div class="cx-card--notify">
              <div class="cx-div">
                <i class="fas fa-circle-notch fa-spin fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="cx-modal map-ngi" v-if="ngi && !loading">
        <div class="cx-modal__body">
          <div class="cx-card--notify">
            <div class="cx-div">
              <div class="cx-div">
                <cx-img 
                  tag="i"
                  class="m-graphic--ngi"
                  imgSrc="/static/graphic/mgto_graphic_location.png"
                ></cx-img>
                <!-- <i class="fas fa-map-marker-alt-slash fa-4x"></i> -->
              </div>
              <div class="cx-div">
                <div class="cx-t20">{{$t('sightMap.ngi')}}</div>
                <div class="cx-t00">{{$t('sightMap.ngiContent')}}</div>
                <a class="cx-link js-pop"
                  v-if="($route.name && $route.name.indexOf('single') > -1) || ngiShowDismissBtn" 
                  @click.prevent="dismissNGILayer">
                  <span class="cx-link__icon">
                    <i class="far fa-times-circle"></i> 
                  </span>
                  <span>{{$t('action.dismiss')}}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let mbgl;
if (process.env.VUE_ENV !== 'server') {
  mbgl = require('mapbox-gl');
}
import { mapState } from 'vuex';
import mapHelper from '@/mixins/mapHelper';
import mapQueueHelper from '@/mixins/mapQueueHelper';
import SightMapSettingControl from '@/components/SightMapSettingControl';
import SightMapVisitorFlowMode from '@/components/SightMapVisitorFlowMode';
import SightMapNearByControl from '@/components/SightMapNearByControl';
import SightMapMapContainerRange from '@/components/SightMapMapContainerRange';
import observeVisibleMap from '@/utils/observeVisibleMap';
import { MAP_INIT } from '@/constants/gtmce';

import axios from 'axios';

// https://3.basecamp.com/3633946/buckets/6317965/todos/8287929004#__recording_8287960601
const tourist_spot_position_overall = [
  {
    regionId: 'S1',
    regionName: '媽閣廟及海事博物館前地',
    coordinates: [
      [113.5301551,22.185357200000002],
      [113.5301551,22.1871552],
      [113.5324371,22.1871552],
      [113.5324371,22.185357200000002],
      [113.5301551,22.185357200000002],
    ],
  },
  {
    regionId: 'S2',
    regionName: '港務局大樓及鄭觀應紀念館',
    coordinates: [
      [113.5324371,22.1871552],
      [113.5324371,22.1889532],
      [113.5347191,22.1889532],
      [113.5347191,22.1871552],
      [113.5324371,22.1871552],
    ],
  },
  {
    regionId: 'S3',
    regionName: '當代藝術中心海事工房',
    coordinates: [
      [113.5301551,22.1835592],
      [113.5301551,22.185357200000002],
      [113.5324371,22.185357200000002],
      [113.5324371,22.1835592],
      [113.5301551,22.1835592],
    ],
  },
  {
    regionId: 'S4',
    regionName: '主教山小堂及瞭望台',
    coordinates: [
      [113.5347191,22.185357200000002],
      [113.5347191,22.1871552],
      [113.5370011,22.1871552],
      [113.5370011,22.185357200000002],
      [113.5347191,22.185357200000002],
    ],
  },
  {
    regionId: 'S5',
    regionName: '觀音蓮花苑',
    coordinates: [
      [113.5506931,22.185357200000002],
      [113.5506931,22.1871552],
      [113.5529751,22.1871552],
      [113.5529751,22.185357200000002],
      [113.5506931,22.185357200000002],
    ],
  },
  {
    regionId: 'S6',
    regionName: '亞婆井前地及鄭家大屋',
    coordinates: [
      [113.5347191,22.1871552],
      [113.5347191,22.1889532],
      [113.5370011,22.1889532],
      [113.5370011,22.1871552],
      [113.5347191,22.1871552],
    ],
  },
  {
    regionId: 'S7',
    regionName: '崗頂前地,何東圖書館大樓,聖若瑟修道院及聖奧斯定堂',
    coordinates: [
      [113.5370011,22.1907512],
      [113.5370011,22.192549200000002],
      [113.5392831,22.192549200000002],
      [113.5392831,22.1907512],
      [113.5370011,22.1907512],
    ],
  },
  {
    regionId: 'S8',
    regionName: '花地瑪聖母堂',
    coordinates: [
      [113.5438471,22.2105292],
      [113.5438471,22.2123272],
      [113.5461291,22.2123272],
      [113.5461291,22.2105292],
      [113.5438471,22.2105292],
    ],
  },
  {
    regionId: 'S9',
    regionName: '九澳七苦聖母小堂',
    coordinates: [
      [113.5872051,22.1314172],
      [113.5872051,22.133215200000002],
      [113.5917691,22.133215200000002],
      [113.5917691,22.1314172],
      [113.5872051,22.1314172],
    ],
  },
  {
    regionId: 'S10',
    regionName: '東望洋炮台',
    coordinates: [
      [113.5484111,22.1961452],
      [113.5484111,22.1979432],
      [113.5506931,22.1979432],
      [113.5506931,22.1961452],
      [113.5484111,22.1961452],
    ],
  },
  {
    regionId: 'S11',
    regionName: '澳門科學館',
    coordinates: [
      [113.5552571,22.185357200000002],
      [113.5552571,22.1871552],
      [113.5598211,22.1871552],
      [113.5598211,22.185357200000002],
      [113.5552571,22.185357200000002],
    ],
  },
  {
    regionId: 'S12',
    regionName: '龍環葡韻,嘉模聖母堂及氹仔市政公園（嘉模公園）',
    coordinates: [
      [113.5575391,22.1511952],
      [113.5575391,22.154791200000002],
      [113.5598211,22.154791200000002],
      [113.5598211,22.1511952],
      [113.5575391,22.1511952],
    ],
  },
  {
    regionId: 'S13',
    regionName: '典當業展示館,魯班先師木工藝陳列館及同善堂歷史檔案陳列館',
    coordinates: [
      [113.5370011,22.1943472],
      [113.5370011,22.1961452],
      [113.5392831,22.1961452],
      [113.5392831,22.1943472],
      [113.5370011,22.1943472],
    ],
  },
  {
    regionId: 'S14',
    regionName: '大三巴牌坊,哪吒廟,耶穌會紀念廣場,戀愛巷,關前薈,俊秀圍／俊秀里',
    coordinates: [
      [113.5392831,22.1961452],
      [113.5392831,22.1979432],
      [113.5415651,22.1979432],
      [113.5415651,22.1961452],
      [113.5392831,22.1961452],
    ],
  },
  {
    regionId: 'S15',
    regionName: '十月初五街,「留聲歲月」音響博物館及康公廟',
    coordinates: [
      [113.5370011,22.1961452],
      [113.5370011,22.1979432],
      [113.5392831,22.1979432],
      [113.5392831,22.1961452],
      [113.5370011,22.1961452],
    ],
  },
  {
    regionId: 'S16',
    regionName: '澳門博物館及大炮台',
    coordinates: [
      [113.5415651,22.1961452],
      [113.5415651,22.1979432],
      [113.5438471,22.1979432],
      [113.5438471,22.1961452],
      [113.5415651,22.1961452],
    ],
  },
  {
    regionId: 'S17',
    regionName: '白鴿巢公園,東方基金會會址及基督教墳場',
    coordinates: [
      [113.5392831,22.199741200000002],
      [113.5392831,22.2015392],
      [113.5415651,22.2015392],
      [113.5415651,22.199741200000002],
      [113.5392831,22.199741200000002],
    ],
  },
  {
    regionId: 'S18',
    regionName: '白鴿巢前地,聖安多尼堂,馬禮遜教堂',
    coordinates: [
      [113.5392831,22.1979432],
      [113.5392831,22.199741200000002],
      [113.5415651,22.199741200000002],
      [113.5415651,22.1979432],
      [113.5392831,22.1979432],
    ],
  },
  {
    regionId: 'S19',
    regionName: '觀音堂及望廈聖方濟各小堂',
    coordinates: [
      [113.5484111,22.2033372],
      [113.5484111,22.2051352],
      [113.5506931,22.2051352],
      [113.5506931,22.2033372],
      [113.5484111,22.2033372],
    ],
  },
  {
    regionId: 'S20',
    regionName: '嚤囉園及通訊博物館',
    coordinates: [
      [113.5529751,22.2015392],
      [113.5529751,22.2033372],
      [113.5552571,22.2033372],
      [113.5552571,22.2015392],
      [113.5529751,22.2015392],
    ],
  },
  {
    regionId: 'S21',
    regionName: '金蓮花廣場',
    coordinates: [
      [113.5529751,22.192549200000002],
      [113.5529751,22.1961452],
      [113.5552571,22.1961452],
      [113.5552571,22.192549200000002],
      [113.5529751,22.192549200000002],
    ],
  },
  {
    regionId: 'S22',
    regionName: '大賽車博物館及澳門基本法紀念館',
    coordinates: [
      [113.5506931,22.1943472],
      [113.5506931,22.1961452],
      [113.5529751,22.1961452],
      [113.5529751,22.1943472],
      [113.5506931,22.1943472],
    ],
  },
  {
    regionId: 'S23',
    regionName: '菩提禪院',
    coordinates: [
      [113.5506931,22.1601852],
      [113.5506931,22.1619832],
      [113.5529751,22.1619832],
      [113.5529751,22.1601852],
      [113.5506931,22.1601852],
    ],
  },
  {
    regionId: 'S24',
    regionName: '觀音古廟,城隍廟及望廈山房',
    coordinates: [
      [113.5461291,22.2051352],
      [113.5461291,22.2069332],
      [113.5484111,22.2069332],
      [113.5484111,22.2051352],
      [113.5461291,22.2051352],
    ],
  },
  {
    regionId: 'S25',
    regionName: '冼星海紀念館',
    coordinates: [
      [113.5484111,22.2051352],
      [113.5484111,22.2069332],
      [113.5506931,22.2069332],
      [113.5506931,22.2051352],
      [113.5484111,22.2051352],
    ],
  },
  {
    regionId: 'S26',
    regionName: '澳門旅遊學院,望廈炮台,望廈山公園及市政牧場舊址（牛房）',
    coordinates: [
      [113.5461291,22.2069332],
      [113.5461291,22.208731200000003],
      [113.5484111,22.208731200000003],
      [113.5484111,22.2069332],
      [113.5461291,22.2069332],
    ],
  },
  {
    regionId: 'S27',
    regionName: '望廈山環境資訊中心',
    coordinates: [
      [113.5484111,22.2069332],
      [113.5484111,22.208731200000003],
      [113.5506931,22.208731200000003],
      [113.5506931,22.2069332],
      [113.5484111,22.2069332],
    ],
  },
  {
    regionId: 'S28',
    regionName: '宋玉生公園及藝園',
    coordinates: [
      [113.5484111,22.1907512],
      [113.5506931,22.1907512],
      [113.55069,22.18895],
      [113.5529751,22.1889532],
      [113.5529751,22.1871552],
      [113.5506931,22.1871552],
      [113.55069,22.18895],
      [113.5484111,22.18895],
      [113.5484111,22.1907512],
    ],
  },
  {
    regionId: 'S29',
    regionName: '何賢公園及中華民族雕塑園',
    coordinates: [
      [113.5506931,22.1907512],
      [113.5484111,22.1907512],
      [113.5484111,22.1943472],
      [113.5506931,22.1943472],
      [113.5506931,22.1907512],
    ],
  },
  {
    regionId: 'S30',
    regionName: '二龍喉公園',
    coordinates: [
      [113.5506931,22.199741200000002],
      [113.5506931,22.2015392],
      [113.5529751,22.2015392],
      [113.5529751,22.199741200000002],
      [113.5506931,22.199741200000002],
    ],
  },
  {
    regionId: 'S31',
    regionName: '松山市政公園',
    coordinates: [
      [113.5506931,22.1979432],
      [113.5506931,22.199741200000002],
      [113.5529751,22.199741200000002],
      [113.5529751,22.1979432],
      [113.5506931,22.1979432],
    ],
  },
  {
    regionId: 'S32',
    regionName: '螺絲山公園',
    coordinates: [
      [113.5506931,22.2033372],
      [113.5506931,22.2051352],
      [113.5529751,22.2051352],
      [113.5529751,22.2033372],
      [113.5506931,22.2033372],
    ],
  },
  {
    regionId: 'S33',
    regionName: '盧廉若公園,澳門茶文化館及葉挺將軍故居',
    coordinates: [
      [113.5461291,22.199741200000002],
      [113.5461291,22.2015392],
      [113.5484111,22.2015392],
      [113.5484111,22.199741200000002],
      [113.5461291,22.199741200000002],
    ],
  },
  {
    regionId: 'S34',
    regionName: '澳門國父紀念館',
    coordinates: [
      [113.5484111,22.199741200000002],
      [113.5484111,22.2015392],
      [113.5506931,22.2015392],
      [113.5506931,22.199741200000002],
      [113.5484111,22.199741200000002],
    ],
  },
  {
    regionId: 'S35',
    regionName: '紀念孫中山市政公園',
    coordinates: [
      [113.5461291,22.2177212],
      [113.5461291,22.2141252],
      [113.5415651,22.2141252],
      [113.5415651,22.215923200000002],
      [113.5438471,22.215923200000002],
      [113.5438471,22.2177212],
      [113.5461291,22.2177212],
    ],
  },
  {
    regionId: 'S36',
    regionName: '南灣湖水上活動中心',
    coordinates: [
      [113.5370011,22.1835592],
      [113.5370011,22.1871552],
      [113.5392831,22.1871552],
      [113.5392831,22.1835592],
      [113.5370011,22.1835592],
    ],
  },
  {
    regionId: 'S37',
    regionName: '花城公園',
    coordinates: [
      [113.5552571,22.154791200000002],
      [113.5552571,22.156589200000003],
      [113.5575391,22.156589200000003],
      [113.5575391,22.154791200000002],
      [113.5552571,22.154791200000002],
    ],
  },
  {
    regionId: 'S38',
    regionName: '石排灣郊野公園,土地暨自然博物館及澳門大熊貓館和珍稀動物館',
    coordinates: [
      [113.5598211,22.1278212],
      [113.5598211,22.1242252],
      [113.5552571,22.1242252],
      [113.5552571,22.126023200000002],
      [113.5575391,22.126023200000002],
      [113.5575391,22.1278212],
      [113.5598211,22.1278212],
    ],
  },
  {
    regionId: 'S39',
    regionName: '路環山頂公園及媽祖文化村',
    coordinates: [
      [113.5621031,22.1224272],
      [113.5621031,22.1242252],
      [113.5643851,22.1242252],
      [113.5643851,22.1224272],
      [113.5621031,22.1224272],
    ],
  },
  {
    regionId: 'S40',
    regionName: '沙梨頭圖書館',
    coordinates: [
      [113.5370011,22.2015392],
      [113.5370011,22.2033372],
      [113.5392831,22.2033372],
      [113.5392831,22.2015392],
      [113.5370011,22.2015392],
    ],
  },
  {
    regionId: 'S41',
    regionName: '澳門旅遊塔會展娛樂中心',
    coordinates: [
      [113.5370011,22.178165200000002],
      [113.5370011,22.1817612],
      [113.5392831,22.1817612],
      [113.5392831,22.178165200000002],
      [113.5370011,22.178165200000002],
    ],
  },
  {
    regionId: 'S42',
    regionName: '澳門漁人碼頭',
    coordinates: [
      [113.5575391,22.1943472],
      [113.5575391,22.1907512],
      [113.5598211,22.1907512],
      [113.5598211,22.1889532],
      [113.5552571,22.1889532],
      [113.5552571,22.1943472],
      [113.5575391,22.1943472],
    ],
  },
  {
    regionId: 'S43',
    regionName: '澳門文化中心,澳門回歸賀禮陳列館及澳門藝術博物館',
    coordinates: [
      [113.5552571,22.1871552],
      [113.5529751,22.1871552],
      [113.5529751,22.1907512],
      [113.5552571,22.1907512],
      [113.5552571,22.1871552],
    ],
  },
  {
    regionId: 'S44',
    regionName: '蓮峯廟及澳門林則徐紀念館',
    coordinates: [
      [113.5461291,22.208731200000003],
      [113.5461291,22.2105292],
      [113.5484111,22.2105292],
      [113.5484111,22.208731200000003],
      [113.5461291,22.208731200000003],
    ],
  },
  {
    regionId: 'S45',
    regionName: '氹仔舊城區,官也街,路氹歷史館,氹仔北帝廟及氹仔天后古廟（天后宮）',
    coordinates: [
      [113.5575391,22.154791200000002],
      [113.5575391,22.1511952],
      [113.5529751,22.1511952],
      [113.5529751,22.1529932],
      [113.5552571,22.1529932],
      [113.5552571,22.154791200000002],
      [113.5575391,22.154791200000002],
    ],
  },
  {
    regionId: 'S46',
    regionName: '黑沙水庫郊野公園',
    coordinates: [
      [113.5689491,22.1242252],
      [113.5689491,22.126023200000002],
      [113.5712311,22.126023200000002],
      [113.5712311,22.1242252],
      [113.5689491,22.1242252],
    ],
  },
  {
    regionId: 'S47',
    regionName: '黑沙公園',
    coordinates: [
      [113.5712311,22.1170332],
      [113.5666671,22.1170332],
      [113.5666671,22.118831200000002],
      [113.5712311,22.118831200000002],
      [113.5712311,22.1170332],
    ],
  },
  {
    regionId: 'S48',
    regionName: '黑沙海灘公園',
    coordinates: [
      [113.5735131,22.1242252],
      [113.5735131,22.1206292],
      [113.5712311,22.1206292],
      [113.5712311,22.118831200000002],
      [113.5689491,22.118831200000002],
      [113.5689491,22.1224272],
      [113.5712311,22.1224272],
      [113.5712311,22.1242252],
      [113.5735131,22.1242252],
    ],
  },
  {
    regionId: 'S49',
    regionName: '竹灣海灘',
    coordinates: [
      [113.5575391,22.1134372],
      [113.5621031,22.1134372],
      [113.5621031,22.111639200000003],
      [113.5575391,22.111639200000003],
      [113.5575391,22.1134372],
    ],
  },
  {
    regionId: 'S50',
    regionName: '路環碼頭',
    coordinates: [
      [113.5484111,22.118831200000002],
      [113.5484111,22.1206292],
      [113.5506931,22.1206292],
      [113.5506931,22.118831200000002],
      [113.5484111,22.118831200000002],
    ],
  },
  {
    regionId: 'S51',
    regionName: '路環舊市區(恩尼斯總統前地)及路環三聖宮（金花廟）',
    coordinates: [
      [113.5506931,22.1170332],
      [113.5506931,22.118831200000002],
      [113.5529751,22.118831200000002],
      [113.5529751,22.1170332],
      [113.5506931,22.1170332],
    ],
  },
  {
    regionId: 'S52',
    regionName: '路環聖方濟各聖堂,路環觀音古廟,路環天后古廟及路環圖書館',
    coordinates: [
      [113.5506931,22.1152352],
      [113.5506931,22.1170332],
      [113.5529751,22.1170332],
      [113.5529751,22.1152352],
      [113.5506931,22.1152352],
    ],
  },
  {
    regionId: 'S53',
    regionName: '譚公廟',
    coordinates: [
      [113.5484111,22.1134372],
      [113.5484111,22.1152352],
      [113.5506931,22.1152352],
      [113.5506931,22.1134372],
      [113.5484111,22.1134372],
    ],
  },
  {
    regionId: 'S54',
    regionName: '路環步行徑',
    coordinates: [
      [113.5575391,22.1206292],
      [113.5575391,22.1224272],
      [113.5598211,22.1224272],
      [113.5598211,22.1206292],
      [113.5575391,22.1206292],
    ],
  },
  {
    regionId: 'S55',
    regionName: '嘉路米耶圓形地(三盞燈)',
    coordinates: [
      [113.5438471,22.2015392],
      [113.5438471,22.2033372],
      [113.5484111,22.2033372],
      [113.5484111,22.2015392],
      [113.5438471,22.2015392],
    ],
  },
  {
    regionId: 'S56',
    regionName: '永樂戲院及蓮溪廟',
    coordinates: [
      [113.5415651,22.2015392],
      [113.5415651,22.2033372],
      [113.5438471,22.2033372],
      [113.5438471,22.2015392],
      [113.5415651,22.2015392],
    ],
  },
  {
    regionId: 'S57',
    regionName: '氹仔中央公園',
    coordinates: [
      [113.5529751,22.1583872],
      [113.5529751,22.1601852],
      [113.5552571,22.1601852],
      [113.5552571,22.1583872],
      [113.5529751,22.1583872],
    ],
  },
  {
    regionId: 'S58',
    regionName: '雅文湖畔及政府總部',
    coordinates: [
      [113.5370011,22.1889532],
      [113.5370011,22.1907512],
      [113.5392831,22.1907512],
      [113.5392831,22.1889532],
      [113.5370011,22.1889532],
    ],
  },
  {
    regionId: 'S59',
    regionName: '新八佰伴',
    coordinates: [
      [113.5392831,22.1907512],
      [113.5392831,22.192549200000002],
      [113.5415651,22.192549200000002],
      [113.5415651,22.1907512],
      [113.5392831,22.1907512],
    ],
  },
  {
    regionId: 'S60',
    regionName: '大潭山郊野公園',
    coordinates: [
      [113.5689491,22.1583872],
      [113.5689491,22.1601852],
      [113.5735131,22.1601852],
      [113.5735131,22.1583872],
      [113.5689491,22.1583872],
    ],
  },
  {
    regionId: 'S61',
    regionName: '澳門高爾夫球鄉村俱樂部',
    coordinates: [
      [113.5780771,22.1242252],
      [113.5780771,22.1278212],
      [113.5803591,22.1278212],
      [113.5803591,22.1296192],
      [113.5826411,22.1296192],
      [113.5826411,22.1242252],
      [113.5780771,22.1242252],
    ],
  },
  {
    regionId: 'S62',
    regionName: '九澳水庫淡水濕地生態區',
    coordinates: [
      [113.5780771,22.1296192],
      [113.5780771,22.1314172],
      [113.5803591,22.1314172],
      [113.5803591,22.1296192],
      [113.5780771,22.1296192],
    ],
  },
  {
    regionId: 'S63',
    regionName: '路環小型賽車場',
    coordinates: [
      [113.5598211,22.1314172],
      [113.5598211,22.133215200000002],
      [113.5621031,22.133215200000002],
      [113.5621031,22.1314172],
      [113.5598211,22.1314172],
    ],
  },
  {
    regionId: 'S64',
    regionName: '氹仔海濱休憩區',
    coordinates: [
      [113.5392831,22.156589200000003],
      [113.5392831,22.1655792],
      [113.5484111,22.1655792],
      [113.5484111,22.163781200000003],
      [113.5415651,22.163781200000003],
      [113.5415651,22.156589200000003],
      [113.5392831,22.156589200000003],
    ],
  },
  {
    regionId: 'S65',
    regionName: '小潭山大型浮雕及暸望台',
    coordinates: [
      [113.5484111,22.1619832],
      [113.5484111,22.163781200000003],
      [113.5506931,22.163781200000003],
      [113.5506931,22.1619832],
      [113.5484111,22.1619832],
    ],
  },
  {
    regionId: 'S66',
    regionName: '澳門東亞運動會體育館',
    coordinates: [
      [113.5689491,22.1386092],
      [113.5689491,22.1422052],
      [113.5712311,22.1422052],
      [113.5712311,22.1386092],
      [113.5689491,22.1386092],
    ],
  },
  {
    regionId: 'S67',
    regionName: '澳門大學',
    coordinates: [
      [113.5392831,22.1242252],
      [113.5392831,22.133215200000002],
      [113.5461291,22.133215200000002],
      [113.5461291,22.1242252],
      [113.5392831,22.1242252],
    ],
  },
  {
    regionId: 'S68',
    regionName: '塔石廣場,中央圖書館,塔石藝文館,饒宗頤學藝館及澳門檔案館',
    coordinates: [
      [113.5461291,22.1979432],
      [113.5461291,22.199741200000002],
      [113.5484111,22.199741200000002],
      [113.5484111,22.1979432],
      [113.5461291,22.1979432],
    ],
  },
  {
    regionId: 'S69',
    regionName: '望德聖母堂',
    coordinates: [
      [113.5438471,22.1961452],
      [113.5438471,22.1979432],
      [113.5461291,22.1979432],
      [113.5461291,22.1961452],
      [113.5438471,22.1961452],
    ],
  },
  {
    regionId: 'S70',
    regionName: '塔石運動場及華士古達嘉馬花園',
    coordinates: [
      [113.5461291,22.1961452],
      [113.5461291,22.1979432],
      [113.5484111,22.1979432],
      [113.5484111,22.1961452],
      [113.5461291,22.1961452],
    ],
  },
  {
    regionId: 'S71',
    regionName: '哪吒古廟及葡萄牙領事館',
    coordinates: [
      [113.5415651,22.1943472],
      [113.5415651,22.1961452],
      [113.5438471,22.1961452],
      [113.5438471,22.1943472],
      [113.5415651,22.1943472],
    ],
  },
  {
    regionId: 'S72',
    regionName: '玫瑰聖母堂,玫瑰堂聖物寶庫及中西藥局舊址',
    coordinates: [
      [113.5392831,22.1943472],
      [113.5392831,22.1961452],
      [113.5415651,22.1961452],
      [113.5415651,22.1943472],
      [113.5392831,22.1943472],
    ],
  },
  {
    regionId: 'S73',
    regionName: '議事亭前地,市政署大樓,郵政總局,仁慈堂博物館,三街會館（關帝廟）及盧家大屋',
    coordinates: [
      [113.5392831,22.192549200000002],
      [113.5392831,22.1943472],
      [113.5415651,22.1943472],
      [113.5415651,22.192549200000002],
      [113.5392831,22.192549200000002],
    ],
  },
  {
    regionId: 'S74',
    regionName: '大堂（主教座堂)',
    coordinates: [
      [113.5415651,22.192549200000002],
      [113.5415651,22.1943472],
      [113.5438471,22.1943472],
      [113.5438471,22.192549200000002],
      [113.5415651,22.192549200000002],
    ],
  },
  {
    regionId: 'S75',
    regionName: '澳門大會堂及公共行政大樓',
    coordinates: [
      [113.5438471,22.192549200000002],
      [113.5438471,22.1943472],
      [113.5461291,22.1943472],
      [113.5461291,22.192549200000002],
      [113.5438471,22.192549200000002],
    ],
  },
  {
    regionId: 'S76',
    regionName: '澳門保安部隊博物館及加思欄花園',
    coordinates: [
      [113.5438471,22.1907512],
      [113.5438471,22.192549200000002],
      [113.5461291,22.192549200000002],
      [113.5461291,22.1907512],
      [113.5438471,22.1907512],
    ],
  },
  {
    regionId: 'S77',
    regionName: '金光大道1區',
    coordinates: [
      [113.5529751,22.1529932],
      [113.5529751,22.1511952],
      [113.5575391,22.1511952],
      [113.5575391,22.1386092],
      [113.5506931,22.1386092],
      [113.5506931,22.1529932],
      [113.5529751,22.1529932],
    ],
  },
  {
    regionId: 'S78',
    regionName: '金光大道2區',
    coordinates: [
      [113.5575391,22.1386092],
      [113.5575391,22.1493972],
      [113.5666671,22.1493972],
      [113.5666671,22.147599200000002],
      [113.5689491,22.147599200000002],
      [113.5689491,22.1386092],
      [113.5575391,22.1386092],
    ],
  },
  {
    regionId: 'S79',
    regionName: '金光大道3區',
    coordinates: [
      [113.5757951,22.140407200000002],
      [113.5757951,22.1386092],
      [113.5689491,22.1386092],
      [113.5689491,22.1493972],
      [113.5735131,22.1493972],
      [113.5735131,22.147599200000002],
      [113.5757951,22.147599200000002],
      [113.5757951,22.1440032],
      [113.5780771,22.1440032],
      [113.5780771,22.140407200000002],
      [113.5757951,22.140407200000002],
    ],
  },
  {
    regionId: 'S80',
    regionName: '林茂塘遊艇碼頭',
    coordinates: [
      [113.5370011,22.2033372],
      [113.5370011,22.2051352],
      [113.5392831,22.2051352],
      [113.5392831,22.2069332],
      [113.5415651,22.2069332],
      [113.5415651,22.2033372],
      [113.5370011,22.2033372],
    ],
  },
  {
    regionId: 'S81',
    regionName: '黑沙龍爪角',
    coordinates: [
      [113.5735131,22.1134372],
      [113.5735131,22.1152352],
      [113.5689491,22.1152352],
      [113.5689491,22.1170332],
      [113.5757951,22.1170332],
      [113.5757951,22.1134372],
      [113.5735131,22.1134372],
    ],
  },
  {
    regionId: 'S82',
    regionName: '大潭山眺望臺',
    coordinates: [
      [113.5598211,22.154791200000002],
      [113.5598211,22.156589200000003],
      [113.5621031,22.156589200000003],
      [113.5621031,22.154791200000002],
      [113.5598211,22.154791200000002],
    ],
  },
];

// https://docs.mapbox.com/mapbox-gl-js/example/restrict-bounds/
export const bounds = [
  // MO
  // [113.460, 22.050], // Southwest coordinates
  // [113.650, 22.290], // Northeast coordinates

  // MO + HK
  [113.42150592511608, 22.064665216092738], // 左下
  [114.41989415288907, 22.538409884736147], // 右上
];

const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export default {
  name: 'sight-map-map-container',
  uit() {
    return [
      ['common', [
        'address', 'tel', 'tempClosedToPublic',
        'lrt',
        'drink', 'nursingroom',
        'busStop', 'restaurant', 'hotel', 'touristInfomation', 'publicToilet',
        'wifi', 'ssid', 'password',
        'fnb', 'qtsasRestaurant'
      ]],
      ['enf', ['searchHeader']],
      ['action', ['close', 'dismiss', 'searchRange']],
      ['sightMap', [
        'ngi',
        'ngiContent',
        'mapboxOutBound',
        // 'pressKeyToZoom'
      ]],
      ['searchOnX', ['searchOnX']],
    ];
  },
  components: {
    SightMapMapContainerRange,
  },
  data() {
    return {
      loading: false,
      ngi: false,
      ngiShowDismissBtn: false,
      showSetting: false,
      map: null,
      mapGeoControl: null,
      trackUserLocation: false,
      mapHeight: null,
      mapContainerUseMapHeight: false,
      mapWidth: null,
      mapClass: {
        'map--sticky': false,
        'map--stick-bottom': false,
      },
      currentDetailCoordinate: '',
      poisOnMap: {},

      scenicHeatData: {
        loading: false,
        ds: null,
        hhmm: null,
        data: [],
      },
    };
  },
  mixins: [mapQueueHelper, mapHelper],
  computed: {
    ...mapState({
      showPOIFilter: state => state.geolocation.showPOIFilter,
      isMapHide: state => state.ui.isMapHide,
      isMobileView: state => state.ui.isMobileView,
      isGeolocationOn: state => state.geolocation.isGeolocationOn,
      showMapOnMobile: state => state.ui.showMapOnMobile,
      mapVisitorFlowMode: state => state.ui.mapVisitorFlowMode,
      disableMapbox: state => state.ui.disableMapbox,
      eventQueue: state => state.sightmapevent.queue,
    }),

    poisFetched() {
      return this.$store.state.sightmap.poi.poisFetched;
    },
    mapPageType() {
      return this.$route.meta.mapPageType;
    },
    poisToShow: {
      get: function () {
        return this.$store.state.sightmap.poi.poisMapFilters.poisToShow;
      },
      set: function (poisToShow) {
        this.cacheFilterOpts({ poisToShow });
        this.$store.dispatch('sightmap/poi/SET_POIS_TO_SHOW', poisToShow);
      },
    },
    range: {
      get: function () {
        return this.$store.state.sightmap.poi.poisMapFilters.range;
      },
      set: function (range) {
        this.cacheFilterOpts({ range });
        this.$store.dispatch('sightmap/poi/SET_POIS_RANGE', range);
      },
    },

    experienceMenu: function() {
      const menu = this.$store.getters['experience/getMenu'](this.$i18n.locale);
      return menu;
    },
    mapContainerStyle: function() {
      if (this.mapContainerUseMapHeight) {
        return {
          height: `${this.mapHeight || 0}px` 
        }
      } 
      return { height: '100%' };
    },
    mapWrapperStyle: function() {
      const style = {
        height: `${this.mapHeight || 0}px`
      }
      if (this.mapWidth) style.width = `${this.mapWidth}px`
      return style;
    },
    poisOnMapCoordinates() {
      return Object.keys(this.poisOnMap).map(lnglat => lnglat.split('|'));
    },

    projectedPOISCount() {
      return this.projectedPOIS.length;
    },
    projectedSightMarkersCount() {
      return this.projectedSightMarkers.length;
    },
  },
  mounted() {
    const windowWidth = document.body.clientWidth;
    const isMapHide = windowWidth < 1088;
    this.$store.dispatch('ui/UPDATE_IS_MAP_HIDE', { isMapHide });

    this.syncFilterOptsCache();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleWindowScroll, window.passiveIfSupported);
    const currentDetailCoordinateRoot = document.querySelector('[data-current-detail-coordinate]');
    const currentDetailCoordinate = currentDetailCoordinateRoot && currentDetailCoordinateRoot.dataset.currentDetailCoordinate;
    if (currentDetailCoordinate) {
      this.currentDetailCoordinate = currentDetailCoordinate.split(',').map(x => +x);
    }
    if (this.disableMapbox) {
      this.handleWindowResize();
      return;
    }
    this._consumMapEventQueue();
    if (!this.isMapHide || this.showMapOnMobile) {
      this.requestMapInit();
    } else {
      window.__initMapOnce = this.requestMapInit;
    }
  },
  beforeDestroy() {
    this.stopWaitingForVisibleMap();
    if (window.__initMapOnce === this.requestMapInit) delete window.__initMapOnce;
    this.$store.dispatch('geolocation/turnOffPOIFilter');
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleWindowScroll, window.passiveIfSupported);
  },
  methods: {
    requestMapInit() {
      const target = this.$refs.map;
      if (!target || this.disableMapbox || this.map || this.loading || (this.isMapHide && !this.showMapOnMobile)) return;

      if (!this.mapPageType) {
        this.initMap();
        return;
      }

      if (!this._stopMapVisibilityObserver) {
        this.handleWindowResize();
        this._stopMapVisibilityObserver = observeVisibleMap(target, this.initMap);
      }
    },
    stopWaitingForVisibleMap() {
      if (this._stopMapVisibilityObserver) {
        this._stopMapVisibilityObserver();
        this._stopMapVisibilityObserver = null;
      }
    },
    async getScenicHeatData() {
      const CACHE_HOUR = 1;
      if (this.scenicHeatData.loading) {
        while (this.scenicHeatData.loading) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        return this.scenicHeatData.data;
      }
      const tsNow = Date.now();
      const ds_hhmm = this.$options.filters.timestampToDateTimeString(tsNow / 1000, 'YMMDD_hhmm');
      const [ds, hhmm] = ds_hhmm.split('_');
      if (
        (this.scenicHeatData.ds && (this.scenicHeatData.ds === ds)) &&
        (this.scenicHeatData.hhmm && (+hhmm - +this.scenicHeatData.hhmm <= 100 * CACHE_HOUR))
      ) {
        return this.scenicHeatData.data;
      }
      let cache = sessionStorage.getItem('scenicHeatCache');
      if (cache) {
        cache = JSON.parse(cache);
        if (
          (cache.ds && (cache.ds === ds)) &&
          (cache.hhmm && (+hhmm - +cache.hhmm <= 100 * CACHE_HOUR))
        ) {
          this.scenicHeatData.data = Object.freeze(cache.data);
          return this.scenicHeatData.data;
        } else {
          sessionStorage.removeItem('scenicHeatCache');
        }
      }
      this.scenicHeatData.loading = true;
      try {
        const response = await axios.get('/api/scenic/open/scenicHeat', { params: { ds, pageSize: 10000 } });
        const res = response.data;
        if (res.data && res.data.length) {
          this.scenicHeatData.data = Object.freeze(res.data.map(item => {
            item.conjestions = (item.conjestions || []).slice(-1);
            if (item.conjestions[0]) {
              this.scenicHeatData.ds = item.conjestions[0].ds || ds;
              this.scenicHeatData.hhmm = item.conjestions[0].hhmm || '';
            }
            return item;
          }));
          sessionStorage.setItem('scenicHeatCache', JSON.stringify({
            ...this.scenicHeatData,
            loading: undefined,
          }));
        }
      } catch (error) {
        console.error(error.response || error);
      }
      this.scenicHeatData.loading = false;
      return this.scenicHeatData.data;
    },
    toggleMarkersBasedOnVisitorFlowMode() {
      if (!this.map) return;
      /*
      if (this.mapVisitorFlowMode) {
        this.projectedPOIS.forEach(poi => (poi._element.hidden = true));
        this.projectedSightMarkers.forEach(marker => (marker._element.hidden = true));
      } else {
        this.projectedPOIS.forEach(poi => (poi._element.hidden = false));
        this.projectedSightMarkers.forEach(marker => (marker._element.hidden = false));
      }
      */
    },

    specialTranslation(tag) {
      let trans = '';
      try {
        trans = this.experienceMenu.find(item => item.category === tag).name;
      } finally {
        return trans;
      }
    },
    _consumMapEventQueue() {
      if (this.disableMapbox) return;
      if (!this.map) return;
      if (this.eventQueue.length === 0) return;
      const { event, playload = {} } = this.eventQueue[0];      
      console.log(`Comsuming map event:`, {event, playload});
      this.$store.dispatch('sightmapevent/dequeueMapEvent');
      this[event] && this[event]({...playload});
    },
    initMap: function({
      center,
      zoom=12.3,
      options={},
      trackScroll=true,
      trackResize=true,
    }={}) {
      if (this.disableMapbox) {
        this.loading = false;
        return;
      }
      if ((this.isMapHide && !this.showMapOnMobile) || !this.$refs.map || this.$refs.map.offsetParent === null) {
        // console.warn('no need to load mbgl', { isMapHide: this.isMapHide, showMapOnMobile: this.showMapOnMobile, mapRef: this.$refs.map });
        return
      }

      if (!center) {
        center = this.currentDetailCoordinate || [113.558, 22.163];
      }

      !trackResize && window.removeEventListener('resize', this.handleWindowResize);
      !trackScroll && window.removeEventListener('scroll', this.handleWindowScroll, window.passiveIfSupported);
      this.handleWindowResize();

      if (this.map != null) { 
        this.$nextTick(() => this.flyTo({center, zoom}));
        return; 
      }
      if (this.loading) {
        return;
      }
      mbgl.accessToken = this.mgtoMapAccessToken;

      // center = center && center.length > 0 ? center : [113.558, 22.163];
      this.map = new mbgl.Map({
        container: this.$refs.map,
        style: this.mgtoMapStyle,
        center,
        zoom,
        scrollZoom: true,
        localIdeographFontFamily: '"Mark Offc Pro Regular", "Lato Bold", "Mark Offc Pro Medium", "Mark Offc Pro Italic", "Noto Sans", "Arial Unicode MS Regular", sans-serif ',
        maxBounds: bounds,
        ...options
      });
      this.loading = true;
      this.stopWaitingForVisibleMap();
      if (this.mapPageType) {
        this.$gtmPush({
          ...MAP_INIT,
          map_page_type: this.mapPageType,
          map_init_reason: 'foreground_visible',
          page_path: this.$route.path,
        });
      }
      this.flyTo({center, zoom});
      this.map.$InqueueMapEvent = this.$InqueueMapEvent;
      this.map.$vm = this;
      this.map.addControl(
        new SightMapSettingControl(), 
        'top-right'
      );
      this.map.addControl(
        new SightMapVisitorFlowMode(), 
        'top-right'
      );
      this.map.addControl(
        new SightMapNearByControl(), 
        'top-right'
      );
      this.map.addControl(
        new mbgl.NavigationControl(), 
        'top-right'
      );

      this.mapGeoControl = new mbgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      });
      // this.mapGeoControl._updateCameraIgnoreMaxBounds = this.mapGeoControl._updateCamera;
      // this.mapGeoControl._updateCamera = function () {
      //   let outOfBounds = false;
      //   if (window._geolocation_check_max_bounds && !window._geolocation_outside_bounds_alerted) {
      //     const bounds = this._map.getMaxBounds();
      //     if (bounds) {
      //       const coords = arguments[0].coords;
      //       if (coords) {
      //         const { longitude, latitude } = coords;
      //         console.log('geolocation:', { longitude, latitude });
      //         if (
      //           longitude >= bounds.getWest() && longitude <= bounds.getEast() &&
      //           latitude >= bounds.getSouth() && latitude <= bounds.getNorth()
      //         ) {
      //           // console.log('geolocation', { longitude, latitude }, 'is within maxBounds', bounds);
      //         } else {
      //           outOfBounds = true;
      //         }
      //       }
      //     }
      //   }
      //   if (outOfBounds) {
      //     window._geolocation_outside_bounds_alerted = true;
      //     alert(this.$t('sightMap.mapboxOutBound'));
      //     return;
      //   }
      //   return this._updateCameraIgnoreMaxBounds.apply(this, arguments);
      // }

      this.$store.dispatch('geolocation/updateMPGC', { 
        controller: this.mapGeoControl
      });

      this.mapGeoControl.on('geolocate', (position) => {
        this.$store.dispatch('geolocation/updateUserGeolocation', { 
          position
        });
      });

      this.mapGeoControl.on('outofmaxbounds', (e) => {
        console.debug(e.type, e.coords)
        if (!window._geolocation_outside_bounds_alerted) {
          window._geolocation_outside_bounds_alerted = true;
          alert(this.$t('sightMap.mapboxOutBound'));
          this.mapGeoControl.trigger();
          setTimeout(() => {
            window._geolocation_outside_bounds_alerted = false;
          }, 500)
        }
      })

      this.mapGeoControl.on('error', (position) => {
        this.$store.dispatch('geolocation/mapBoxGeolocationFail');
      });

      this.mapGeoControl.on('trackuserlocationstart', () => {
        // window._geolocation_check_max_bounds = true;
        this.trackUserLocation = true;
        this.$store.dispatch('geolocation/turnOnMapBoxGeolocation');
      });

      this.mapGeoControl.on('trackuserlocationend', () => {
        // window._geolocation_check_max_bounds = false;
        this.trackUserLocation = false;
        // this.$store.dispatch('geolocation/turnOffMapBoxGeolocation');
      });

      this.map.addControl(
        this.mapGeoControl, 
        'top-right'
      );

      this.map.addControl(
        new mbgl.ScaleControl({
          maxWidth: 50,
          unit: 'metric'
        }),
        'top-right'
      );

      setTimeout(this.handleMapLoad, 1000);
      this.map.on('style.load', () => {
        this.switchMapLocale();
        this.blackAndWhite && this.switchMapToGrayscale();
        this.updatePOIs();

        // Display zoom level for testing
        // this.displayZoomLevel(); // 測試完成，已隱藏

        this.$nextTick(() => {
          if (this.mapVisitorFlowMode) {
            this.getScenicHeatData().then(data => {
              const heatmapRects = [];
              tourist_spot_position_overall.forEach(region => {
                if (region.coordinates.length < 1) return;
                const item = data.find(item => item.regionId === region.regionId);
                if (item && item.conjestions && item.conjestions[0] && item.conjestions[0].color) {
                  const rect = {
                    ...region,
                    color: item.conjestions[0].color,
                    totalCount: item.conjestions[0].totalCount,
                  };
                  heatmapRects.push(rect);
                }
              });
              const geojson = {
                type: "FeatureCollection",
                features: heatmapRects.map(rect => ({
                  type: "Feature",
                  properties: {
                    regionId: rect.regionId,
                    regionName: rect.regionName,
                    color: rect.color,
                    totalCount: rect.totalCount
                  },
                  geometry: {
                    type: "Polygon",
                    coordinates: [rect.coordinates]
                  }
                }))
              };
              if (this.map.getSource('heatmap-rects')) {
                this.map.removeSource('heatmap-rects');
              }
              if (this.map.getLayer('heatmap-rects-layer')) {
                this.map.removeLayer('heatmap-rects-layer');
                this.map.removeLayer('heatmap-rects-outline');
              }
              this.map.addSource('heatmap-rects', {
                type: 'geojson',
                data: geojson
              });
              this.map.addLayer({
                id: 'heatmap-rects-layer',
                type: 'fill',
                source: 'heatmap-rects',
                paint: {
                  'fill-color': ['get', 'color'], // Use the color property from your data
                  'fill-opacity': 0.5
                }
              });
              this.map.addLayer({
                id: 'heatmap-rects-outline',
                type: 'line',
                source: 'heatmap-rects',
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 2,
                  'line-opacity': 1 // fully opaque
                }
              });
            });
          } else {
            if (this.map.getSource('heatmap-rects')) {
              this.map.removeSource('heatmap-rects');
            }
            if (this.map.getLayer('heatmap-rects-layer')) {
              this.map.removeLayer('heatmap-rects-layer');
              this.map.removeLayer('heatmap-rects-outline');
            }
          }
          this.toggleMarkersBasedOnVisitorFlowMode();
        });

      });

      this.$nextTick(() => {
        if (this.mapVisitorFlowMode) {
          this.getScenicHeatData();
        }
      });
    },
    updateProjectedSightMarkersVisibility: function(e) {
      if (this.projectedSightMarkers.length === 0) {
        return;
      }

      const dotClass = 'm-sight-marker--dot';

      const bounds = this.map.getBounds();
      const zoom = this.map.getZoom();

      const visibleMarkers = [];
      // const invisibleMarkers = [];

      this.projectedSightMarkers.forEach(marker => {
        const lngLat = marker.getLngLat();
        if (
          lngLat.lng >= bounds.getWest() &&
          lngLat.lng <= bounds.getEast() &&
          lngLat.lat >= bounds.getSouth() &&
          lngLat.lat <= bounds.getNorth()
        ) {
          visibleMarkers.push(marker);
        } else {
          // invisibleMarkers.push(marker);
        }
        marker._element.classList.add(dotClass);
      });

      let maxShow = 3;
      if (zoom >= 15) {
        maxShow = 50;
      } else if (zoom >= 14) {
        maxShow = 30;
      } else if (zoom >= 13) {
        maxShow = 10;
      } else if (zoom >= 12) {
        maxShow = 5;
      }
      const randomVisible = () => {
        const randomMarkersNotToBeDot = visibleMarkers.sort(() => 0.5 - Math.random()).slice(0, maxShow);
        randomMarkersNotToBeDot.forEach(marker => marker._element.classList.remove(dotClass));
      }
      randomVisible();
    },
    handleMapLoad: function() {
      this.handleWindowResize();
      this.map && this.map.resize();
      this.isGeolocationOn && this.mapGeoControl.trigger();
      setTimeout(() => {
        this.loading = false;
        if (this.showMapOnMobileAfterHandler) {
          this.showMapOnMobileAfterHandler();
          this.showMapOnMobileAfterHandler = null;
        }
        // https://3.basecamp.com/3633946/buckets/6317965/todos/9299791774
        this._updateProjectedSightMarkersVisibility = debounce(this.updateProjectedSightMarkersVisibility, 100);
        // this.map.on('zoomend', this._updateProjectedSightMarkersVisibility);
        this.map.on('moveend', this._updateProjectedSightMarkersVisibility);
      }, 50);
    },
    updateMapHeight: function() {
      const headerHeight = (document.querySelector('header') || {}).offsetHeight || 0;
      const footerHeight = (document.querySelector('footer') || {}).offsetHeight || 0;
      const windowHeight = window.innerHeight;
      const maxHeight = windowHeight - headerHeight - (this.isMapHide ? 0 : footerHeight);
      const ContentDOM = document.querySelector('.sight-map-content');
      let contentHeight = ContentDOM ? ContentDOM.offsetHeight : 0;
      if (contentHeight < maxHeight) { contentHeight = maxHeight; }
      const newMapHeight = contentHeight > windowHeight ? windowHeight : contentHeight;
      if (newMapHeight !== this.mapHeight) {
        this.mapHeight = newMapHeight;
        this.mapContainerUseMapHeight = newMapHeight >= contentHeight;
        this.$nextTick(this.resizeMap);
        console.log("[MAP] Height updated:", this.mapHeight);
      }
    },
    updateMapWidth: function() {
      const newMapWidth = this.$refs.mapContainer && this.$refs.mapContainer.offsetWidth;

      if (newMapWidth !== this.mapWidth) {
        this.mapWidth = newMapWidth;
        this.$nextTick(this.resizeMap);
        console.log("[MAP] Width updated:", this.mapWidth);
      }

      const ContentDOM = document.querySelector('.sight-map-content');
      const contentWidth = ContentDOM ? ContentDOM.offsetWidth : 0;
      const windowWidth = document.body.clientWidth;
      const isMapHide = windowWidth == contentWidth && windowWidth < 1088;
      this.$store.dispatch('ui/UPDATE_IS_MAP_HIDE', { isMapHide });
    },
    updateMapClass: function() {
      if (this.showMapOnMobile) {
        this.mapClass['map--sticky'] = false;
        this.mapClass['map--stick-bottom'] = false;
        this.mapWidth = null;
        return ;
      }

      const headerHeight = (document.querySelector('header') || {}).offsetHeight || 0;
      const footerHeight = (document.querySelector('footer') || {}).offsetHeight || 0;
      let htmlHeight = document.documentElement.offsetHeight;
      let scrollY = window.scrollY || window.pageYOffset;

      // normal layout
      if (scrollY < headerHeight) {
        this.mapClass['map--sticky'] = false;
        this.mapClass['map--stick-bottom'] = false;
        this.mapWidth = null;

        console.log("[MAP] Update Class: Normal");
        return;
      }

      // need to stick to footer
      if (htmlHeight - scrollY - this.mapHeight <= footerHeight) {
        this.mapClass['map--sticky'] = false;
        this.mapClass['map--stick-bottom'] = true;
        this.mapWidth = null;

        console.log("[MAP] Update Class: Stick Botom");
        return;
      }

      // fixed to top
      this.mapClass['map--sticky'] = true;
      this.mapClass['map--stick-bottom'] = false;
      this.updateMapWidth();
      console.log("[MAP] Update Class: Fixed Top");
    },
    handleWindowResize: function() {
      this.updateMapHeight();
      this.updateMapWidth();
      this.updateMapClass();    
    },
    handleWindowScroll: function() {
      this.updateMapClass();
    },
    
    handleVisitorFlowSwitch: function() {
      if ([
        'visitor-flow-forecast',
        'visitor-flow',
      ].includes(this.$route.params.tagId)) {
        this.$store.dispatch('ui/UPDATE_MAP_VISITOR_FLOW_MODE', { mapVisitorFlowMode: true });
      } else {
        this.$store.dispatch('ui/UPDATE_MAP_VISITOR_FLOW_MODE', { mapVisitorFlowMode: false });
      }
    },

    /**
     * handleShowSetting
     */
    handleShowSetting: function() {
      this.showSetting = true;
    },

    /**
     * handleShowVisitorFlow
     */
    handleShowVisitorFlow: function(e) {
      this.$store.dispatch('ui/UPDATE_MAP_VISITOR_FLOW_MODE', { mapVisitorFlowMode: !this.mapVisitorFlowMode });
    },

    /**
     * Clear Map 
     */
    clearMap: function() {
      console.log('clear');
    },
    /**
     * NGI LAYER
     */
    activeNGILayer: function({ngiShowDismissBtn=false}) {
      this.ngi = true;
      this.ngiShowDismissBtn = !!ngiShowDismissBtn;
    },
    dismissNGILayer: function() {
      this.ngi = false;
      this.ngiShowDismissBtn = false;
    },
    shouldShowPoi(poi) {
      const { type, distance, id } = poi.getElement().dataset;
      const { lng, lat } = poi.getLngLat();
      if (distance <= this.range && this.poisToShow[type]) {
        poi.addTo(this.map);
        this.$set(this.poisOnMap, `${lng}|${lat}`, poi);
      } else {
        poi.remove();
        this.$delete(this.poisOnMap, `${lng}|${lat}`);
      }
    },
    updatePOIs() {
      if (this._updatePOIsTimer) {
        clearTimeout(this._updatePOIsTimer);
        this._updatePOIsTimer = null;
      }
      this._updatePOIsTimer = setTimeout(() => {
        this.projectedPOIS.forEach(this.shouldShowPoi);
        this.rerenderProjectedActiveMarker();
      }, 100);
    },
    setPoisToShow(field, value) {
      if (field) {
        this.poisToShow = {
          ...this.poisToShow,
          [field]: value,
        };
      } else if (value && typeof value === 'object') {
        this.poisToShow = {
          ...this.poisToShow,
          ...value,
        };
      }
    },
    setPoisRange(value) {
      this.range = value;
    },

    cacheFilterOpts({ poisToShow, range }, expires) {
      if (this.syncingFilterOptsCache) {
        return
      }
      localStorage.setItem('map_filter_opts', JSON.stringify({
        poisToShow: poisToShow || this.poisToShow,
        range: range || this.range,
        expires: expires || (Date.now() + 86400000 * 30),
      }));
    },
    syncFilterOptsCache() {
      const cache = localStorage.getItem('map_filter_opts');
      const opts = cache && JSON.parse(cache);
      if (opts && opts.expires > Date.now()) {
        this.syncingFilterOptsCache = true
        if (opts.poisToShow && typeof opts.poisToShow === 'object') {
          this.setPoisToShow(null, opts.poisToShow);
        }
        if (opts.range && typeof opts.range === 'number') {
          this.setPoisRange(opts.range);
        }
        this.$nextTick(() => this.syncingFilterOptsCache = false)
      } else {
        localStorage.removeItem('map_filter_opts');
      }
    },
  },
  watch: {
    "isGeolocationOn": function() {
      if (this.isGeolocationOn != this.trackUserLocation && this.mapGeoControl) {
        this.mapGeoControl.trigger();
      }
    },
    "eventQueue.length": function() {
      if (this.disableMapbox) return;
      this._consumMapEventQueue();
    },
    '$route.path': function() {
      const wasWaitingForVisibleMap = !!this._stopMapVisibilityObserver;
      this.stopWaitingForVisibleMap();
      this.toggleMarkersBasedOnVisitorFlowMode();
      this.handleWindowResize();
      if ((wasWaitingForVisibleMap || this.mapPageType) && (!this.isMapHide || this.showMapOnMobile)) {
        this.$nextTick(this.requestMapInit);
      }
    },
    '$route.params.tagId': {
      handler() {
        this.handleVisitorFlowSwitch();
      },
      immediate: true,
    },
    'mapVisitorFlowMode': function(mapVisitorFlowMode) {
      if (this.map) {
        if (mapVisitorFlowMode) {
          this.map.setStyle(this.mgtoMapStyleVisitorFlow);
        } else {
          this.map.setStyle(this.mgtoMapStyleDefault);
        }
      }
    },
    'projectedPOISCount': function(count) {
      if (count > 0) {
        this.toggleMarkersBasedOnVisitorFlowMode();
      }
    },
    'projectedSightMarkersCount': function(count) {
      if (count > 0) {
        this.toggleMarkersBasedOnVisitorFlowMode();
      }
    },
    'showMapOnMobile': function(show) {
      const handler = () => {
        this.handleWindowResize();
        this.map && this.map.resize();
        window.scroll(0, 0);
        show && this.$nextTick(() => this.repositionToProjectedObjects(this.poisOnMapCoordinates));
      }
      if (show && !this.disableMapbox && !this.map) {
        this.showMapOnMobileAfterHandler = handler;
        this.$nextTick(this.requestMapInit);
      } else if (!show) {
        this.showMapOnMobileAfterHandler = null;
        if (this.isMapHide) this.stopWaitingForVisibleMap();
      }
      handler()
    },
    'isMapHide': function(hide, prevHide) {
      if (hide && !this.showMapOnMobile) {
        this.stopWaitingForVisibleMap();
      } else if (prevHide && !hide) {
        this.$nextTick(this.requestMapInit);
      }
    },
    'projectedPOISID': {
      handler(val) {
        if (val && !this.showPOIFilter) {
          this.$store.dispatch('geolocation/turnOnPOIFilter');
        } else if (!val && this.showPOIFilter) {
          this.$store.dispatch('geolocation/turnOffPOIFilter');
          this.showSetting = false;
        }
      },
      // immediate: true,
    },
    /**
     * flyTo on first load logic:
     * projectedPOIS.length --> _updatePOIs -
     * -> shouldShow --> poisOnMap --> poisOnMapCoordinates --> flyTo
     */
    // only flyTo based on target's coordinates if is initial load, flyTo logic at SightMapSingleView.vue 
    // do not flyTo based on pois when if is initial load
    // ref: https://3.basecamp.com/3633946/buckets/6317965/todos/4387425170#__recording_4417101493
    // 'projectedPOIS.length': {
    //   handler(length) {
    //     if (length > 0) {
    //       // this.updatePOIs();
    //       this._updatePOIs();
    //     }
    //   },
    // },
    /**
     * flyTo on filter change logic:
     * range, poisToShow --> updatePOIs -
     * -> shouldShow --> poisOnMap --> poisOnMapCoordinates --> flyTo
    */
    // only flyTo based on pois if toggle filters
    'range': {
      handler() {
        this.updatePOIs();
      },
    },
    'poisToShow': {
      handler() {
        this.updatePOIs();
      },
      deep: true,
    },
    'poisFetched': {
      handler() {
        if (this._poisFetchedTimer) {
          clearTimeout(this._poisFetchedTimer);
          this._poisFetchedTimer = null;
        }
        this._poisFetchedTimer = setTimeout(() => {
          this.updatePOIs();
        }, 300);
      },
    },
    // 'projectedPOIS': {
    //   handler() {
    //     this.updatePOIs();
    //   },
    //   deep: true,
    // },
    /**
     * flyTo handler
     */
    // no need to zoom based on pois
    // ref: https://3.basecamp.com/3633946/buckets/6317965/messages/4305436588#__recording_4430573277
    // 'poisOnMapCoordinates': {
    //   handler(coordinates) {
    //     if (coordinates.length > 0) {
    //       this.map.$InqueueMapEvent([
    //         'updateMapHeight',
    //         {
    //           event: 'flyTo', 
    //           playload: { 
    //             center: coordinates,
    //             zoom: 15
    //           }
    //         }
    //       ]);
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style lang="scss">
  .theme-color-fnb{
    @include link-color($theme-color-fnb);
  }

  .theme-color-restaurant{
    @include link-color($theme-color-restaurant);
  }

  .theme-color-whatson{
    @include link-color($theme-color-whatson);
  }

  .theme-color-hotel{
    @include link-color($theme-color-hotel);
  }

  .theme-color-lrt{
    @include link-color($theme-color-lrt);
  }

  .theme-color-freewifi{
    @include link-color($theme-color-freewifi);
  }

  .theme-color-touristinfo{
    @include link-color($theme-color-touristinfo);
  }

  .theme-color-drink{
    @include link-color($theme-color-drink);
  }

  .theme-color-nursingroom{
    @include link-color($theme-color-nursingroom);
  }

  .theme-color-publictoilet{
    @include link-color($theme-color-publictoilet);
  }

  .theme-color-busstop{
    @include link-color($theme-color-busstop);
  }

  .cx-marker.-active{
    &::before{
      background-color: $color-red;
    }
  }

  .cx-icon.sm{
    width: $icon-size-sm;
    line-height: $icon-size-sm;
    font-size: $icon-font;
    box-shadow: 0 0 0 2px currentColor inset;
  }

  .cx-card::after{
    display: none;
  }
  .m-legend{
    &--abs {
      z-index: 90;
      padding: 0.7rem 1rem;
      position: absolute;
      background-color: $color-white;
      top: 0;
      left: 0;
      right: 0;
      box-shadow: 0 15px 15px 0 rgba($color-black, .1);
    }
    &__link{
      margin: .25rem 0;
      padding: .25rem;
      border: 1px solid $color-border;
      border-radius: $br-base;
      cursor: pointer;
    }
    &--close{
      align-self: flex-start;
      cursor: pointer;
    }
  }

  .mapboxgl-popup{
    z-index: 2;
    filter: drop-shadow(0 1px 2px rgba(#000, .2));
  }
  .m-popup{
    font-family: 'Noto Sans', sans-serif;
    &.mapboxgl-popup-anchor{
      &-bottom {
        .mapboxgl-popup-content{
          bottom: -10px;
        }
      }
      &-top {
        .mapboxgl-popup-content{
          top: -10px;
        }
      }
      &-left {
        .mapboxgl-popup-content{
          left: -10px;
        }
      }
      &-right {
        .mapboxgl-popup-content{
          right: -10px;
        }
      }
    }
    .mapboxgl-popup-content{
      @extend .cx-card;
      @include set-font(.4);
      background: transparent;
      width: 250px;
      box-shadow: none;
      font-size: 13px;
      .cx-t02, .cx-t10{
        font-size: 11px;
      }
      .popup-wrapper {
        background: transparent;
        padding: 10px;
        pointer-events: none;
      }
      article{
        pointer-events: auto;
        background: $color-white;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .cx-media--cover{
          order: 1;
          border-top-left-radius: $br-base;
          border-top-right-radius: $br-base;
          overflow: hidden;
        }
        .cx-wrap{
          order: 2;
          padding: $space-sm;
          // min-height: 75px;
          div + div{
            margin-top: $int-space-sm;
          }
        }
        .cx-t20{
          // padding-right: 20px;
        }
        p{
          line-height: 1.3;
        }
      }

      .mapboxgl-popup-close-button {
        position: absolute;
        background-color: rgba($color-black, .1);
        border-bottom-left-radius: $br-base;
        color: $color-white;
        text-shadow: 0 0 2px $color-pureblack;
        font-size: $font-md;
        right: 10px;
        top: 10px;
        padding: 0;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-weight: bold;
        z-index: 2;
        &:active, &:focus{
          outline: 0;
          background-color: rgba($color-black, .3);
        }
      }
    }
  }

  #map{
    width: 100%;
    height: 100%;
    background-color: rgb(218, 218, 218);
  }

  .map-static-placeholder {
    width: 100%;
    height: 100%;
    min-height: 16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(238, 238, 238);
  }

  .map{
    &-wrapper{ 
      position: relative;
      width: 100%;
      .mapboxgl-marker{
        cursor: pointer;
        z-index: 2;
        &:hover{
          text-decoration: none;
        }
        &[data-dismiss-class="outdated-marker"]{
          z-index: 1;
          &:hover {
            z-index: 3;
          }
        }
      }
    }

    &-container {
      width: 100%;
      height: 100%;
      // min-height: 600px;
      position: relative;
    }

    &--sticky{
      position: fixed;
      top: 0px;
      right: 0px;
    }

    &--stick-bottom{
      position: absolute;
      bottom: 0px;
      right: 0px;
    }

    &-loading{
      background-color: $color-midgrey;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-ngi{
      background-color: $color-midgrey;
      opacity: .9;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-marker--point{
      width: 13px;
      height: 13px;
      background-color: $color-red;
      border: 2px solid $color-white;
      border-radius: 20px;
      // &:hover{
      //   width: 20px;
      //   height: 20px;
      //   cursor: pointer;
      // }
    }
  }

  @supports (position: sticky) {
    .map-wrapper,
    .map-wrapper.map--sticky,
    .map-wrapper.map--stick-bottom {
        position: sticky;
        top: 0;
        right: 0;
    }
  }

  .event-map-loading-enter-active,
  .event-map-loading-leave-active {
    transition: opacity 180ms ease-out;
  }

  .event-map-loading-enter,
  .event-map-loading-leave-to {
    opacity: 0;
  }

  .event-map-loading-leave-active {
    pointer-events: none;
  }

  @media (prefers-reduced-motion: reduce) {
    .event-map-loading-enter-active,
    .event-map-loading-leave-active {
      transition: none;
    }

    .event-map-loading .fa-spin {
      animation: none;
    }
  }

  .m-inactive {
    color: $color-midgrey;
    &:hover {
      color: $color-darkgrey;
    }
  }

  .m-sight-marker:not([data-active="1"]){
    &:hover {
      z-index: 2;
    }
  }

  // Fix for transparent container hit detection in Chrome
  // Chrome treats elements with pointer-events: none children and no background as "hollow"
  // Using a near-invisible background forces Chrome to treat the entire area as solid
  .m-sight-marker {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.01); // Chrome hit-testing fix
  }

  .m-sight-marker.m-sight-marker--dot:not(:hover) {
    z-index: 1;
  }
  // .m-sight-marker.m-sight-marker--dot:hover > .cx-icon,
  .m-sight-marker.m-sight-marker--dot:not(:hover) > .cx-icon {
    width: 12px;
    height: 12px;
    font-size: 0;
    background-color: currentColor;
    border: 2px solid #fff;
  }

  // Ensure child elements don't intercept mouse events
  // This allows hover to work on the entire marker area, not just the border
  .m-sight-marker > * {
    pointer-events: none;
  }
  
  .m-sight-marker[data-active="1"]:hover + .m-subsight-marker,
  .m-sight-marker[data-active="1"] + .m-subsight-marker:hover {
    z-index: 2;
  }

  .m-subsight-marker--bunlde {
    position: absolute;
    bottom: 30px;
    left: 15px;
    z-index: 100;
  }

  .mapboxgl-popup-content{
    padding: 0;
  }
  .mapboxgl-marker:hover {    /* .m-sight-marker:hover */
      z-index: 2;
  }
  .mapboxgl-popup-anchor-bottom {
      margin-top: -11px;
  }
  .mapboxgl-popup-anchor-top {
      margin-top: 11px;
  }
  .mapboxgl-popup-anchor-left {
      margin-left: 11px;
  }
  .mapboxgl-popup-anchor-right {
      margin-left: -11px;
  } 

  .mapboxgl-popup-anchor-bottom-left {
    .mapboxgl-popup-content {
      margin-bottom: -10px;
      left: -10px;
    }
    article{
      border-bottom-left-radius: 0px !important;
    }
  }

  .mapboxgl-popup-anchor-bottom-right {
    .mapboxgl-popup-content {
      margin-bottom: -10px;
      left: 10px;
    }
    article{
      border-bottom-right-radius: 0px !important;
    }
  }

  .mapboxgl-popup-anchor-top-left {
    .mapboxgl-popup-content {
      margin-top: -10px;
      left: -10px;
    }
    article{
      border-top-left-radius: 0px !important;
      .cx-media--cover {
        border-top-left-radius: 0px !important;
      }
    }
  }

  .mapboxgl-popup-anchor-top-right {
    .mapboxgl-popup-content {
      margin-top: -10px;
      left: 10px;
    }
    article{
      border-top-right-radius: 0px !important;
      .cx-media--cover {
        border-top-right-radius: 0px !important;
      }
    }
  }
</style>
